import { FormikProps, useFormik } from 'formik';
import { getAddBugReportTypesFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { FormikValues } from 'formik/dist/types';
import { useState } from 'react';
import { IBugReportType } from '../../../../types/interfaces/bug-report-type';
import {
  useGetBugReportTypes,
  usePostPutBugReportType,
} from '../../../../services/redux/api/bugReportApi';

export function useBugReportTypeComponent(
  onClose: () => void,
  bugReportType?: IBugReportType,
) {
  const { t } = useTranslation();
  const [postPutBugReportType, { isLoading }] = usePostPutBugReportType();
  const { data: bugReportTypes } = useGetBugReportTypes();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddBugReportTypesFormValidation(t),
    initialValues: {
      nameKey: bugReportType?.nameKey || '',
      priority: bugReportType?.priority || '',
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutBugReportType({
      id: bugReportType?.id,
      body: {
        nameKey: values.nameKey,
        priority: values.priority,
      },
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  return {
    formik,
    isLoading,
    bugReportTypes,
  };
}
